import React from 'react';

import { MapTo } from '@adobe/aem-spa-component-mapping';

import { BulletList } from 'components/ExpertSearch/components/BulletList/BulletList';
import { MailHotline } from 'components/ExpertSearch/components/MailHotline/MailHotline';
import { PageTitleSection } from 'components/PageTitleSection/PageTitleSection';

export const MapSupportInstallerSupport = () => {
  return (
    <div className="expert-page einspeiseranschluss">
      <div className="expert-page-content-stage-text">
        <PageTitleSection
          title="Fragen zu mein Auftragsportal mAP und zur Eintragung als Installateur"
          notFramed
        />
        <MailHotline>
          <p>
            Postfach: <a href="mailto:map@lew-verteilnetz.de">map@lew-verteilnetz.de</a>
          </p>

          <p>Hotline: 0821/49809080</p>
        </MailHotline>

        <BulletList
          title="Themen"
          items={
            <>
              <li>
                Fragen zur Handhabung mAP (z.B. „...ist der Auftrag angekommen? ...wie lege ich
                einen Auftrag an?“)
              </li>
              <li>Zugangsprobleme mAP</li>
              <li>Eintragung ins Installateursverzeichnis</li>
            </>
          }
        />
        <BulletList
          title="Was gehört nicht dazu"
          items={
            <>
              <li>Fragen zum mHAP mein Hausanschlussportal</li>
              <li>Status zu Aufträgen</li>
              <li>Fragen zum IPN</li>
            </>
          }
        />
      </div>
    </div>
  );
};
MapTo('e-fix/components/content/mapsupportinstallersupport')(MapSupportInstallerSupport);
